import { computed } from 'vue'

/**
 * Khi VITE_IS_RELEASE_VERSION=true, ẩn chợ thứ cấp và các mục tài khoản mở rộng (cùng cờ với header).
 */
export function useReleaseFeatureFlags() {
  const showMarketplaceNav = computed(
    () => import.meta.env.VITE_IS_RELEASE_VERSION !== 'true',
  )
  return { showMarketplaceNav }
}
